@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_028_128_878)
public val Res.drawable.app_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
public val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_542_677_704)
public val Res.drawable.ic_apple: DrawableResource by lazy {
      DrawableResource("drawable:ic_apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_apple.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_002_404_028)
public val Res.drawable.ic_google: DrawableResource by lazy {
      DrawableResource("drawable:ic_google", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_logo", Res.drawable.app_logo)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_apple", Res.drawable.ic_apple)
  map.put("ic_google", Res.drawable.ic_google)
}
